import React from 'react';

function ManageSubscriptionsView({
  subscriptions,
  onBack,
  onDiscoverCreators,
  onUpgrade,
  onSwitchToFree,
  onUnsubscribe
}) {
  return (
    <div className="space-y-6" data-testid="manage-subscriptions-view">
      {/* Back button */}
      <button
        onClick={onBack}
        className="flex items-center gap-2 text-primary font-semibold hover:underline"
        data-testid="back-to-profile-button"
      >
        <span>←</span> Back to Profile
      </button>

      <h2 className="text-2xl font-heading font-bold">Manage Subscriptions</h2>

      {subscriptions.length === 0 ? (
        <div className="bg-white rounded-card shadow-card p-8 text-center">
          <p className="text-gray-500 mb-4">No active subscriptions</p>
          <button
            onClick={onDiscoverCreators}
            className="bg-primary text-white px-6 py-3 rounded-button font-semibold hover:shadow-hover"
          >
            Discover Foodies
          </button>
        </div>
      ) : (
        <div className="space-y-4">
          {subscriptions.map(sub => (
            <div key={sub.subscription_id} className="bg-white rounded-card shadow-card p-6">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-16 h-16 rounded-full bg-primary flex items-center justify-center text-white text-xl font-bold flex-shrink-0">
                  {sub.creator.name?.charAt(0).toUpperCase()}
                </div>
                <div className="flex-1">
                  <h3 className="font-heading font-bold text-lg">{sub.creator.name}</h3>
                  <p className="text-sm text-gray-600 mb-1">{sub.creator.review_count || 0} recommendations</p>
                  <p className="text-sm font-semibold text-primary">
                    Current Plan: {sub.tier === 'premium' ? `$${sub.creator.subscription_price}/mo (Premium)` : 'Free'}
                  </p>
                </div>
              </div>
              
              <div className="flex gap-3">
                {sub.tier === 'premium' ? (
                  <button
                    onClick={() => onSwitchToFree(sub.creator.name)}
                    className="flex-1 bg-secondary text-white py-3 px-4 rounded-button font-semibold hover:opacity-90"
                    data-testid={`switch-free-${sub.subscription_id}`}
                  >
                    Switch to Free Tier
                  </button>
                ) : (
                  <button
                    onClick={() => onUpgrade(sub.creator.user_id, sub.creator.name, sub.creator.subscription_price)}
                    className="flex-1 bg-primary text-white py-3 px-4 rounded-button font-semibold hover:shadow-hover"
                    data-testid={`switch-paid-${sub.subscription_id}`}
                  >
                    Upgrade to Paid Tier
                  </button>
                )}
                
                <button
                  onClick={() => onUnsubscribe(sub.subscription_id, sub.creator.name, sub.creator.user_id)}
                  className="flex-1 border-2 border-red-500 text-red-500 py-3 px-4 rounded-button font-semibold hover:bg-red-500 hover:text-white transition-all"
                  data-testid={`unsubscribe-${sub.subscription_id}`}
                >
                  Unsubscribe
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ManageSubscriptionsView;
